/**
 * DeckBackgroundLayer — full-bleed background behind every slide.
 *
 * Renders a single `ParticleOverlay` for the deck-level
 * `defaultBackground` (defaults to the marketing-landing ambient orbs
 * via the `ambient-orbs` code path inside `ParticleOverlay`). Kept
 * visually behind the page-transition layer stack so the chosen
 * background peek through during transitions.
 *
 * Z-index: capped at `2` so it never collides with the page-transition
 * stages (which live at 3..5) or the slide content layers.
 */
import { ParticleOverlay } from '../particles/ParticleOverlay';

export interface DeckBackgroundLayerProps {
  /** Code from `AMBIENT_EFFECTS`. Defaults to `floating-heart-bokeh`. */
  code?: string;
  /** Default intensity for the background. */
  intensity?: number;
}

export function DeckBackgroundLayer({
  code = 'floating-heart-bokeh',
  intensity = 0.6,
}: DeckBackgroundLayerProps) {
  return (
    <div
      className="pointer-events-none absolute inset-0"
      style={{ zIndex: 1 }}
      aria-hidden="true"
    >
      <ParticleOverlay code={code} intensity={intensity} />
    </div>
  );
}
